let cachedFontBase64 = null;

function arrayBufferToBase64(buffer) {
  const bytes = new Uint8Array(buffer);
  let binary = '';
  for (let i = 0; i < bytes.byteLength; i += 1) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
}

async function loadFontBase64() {
  if (cachedFontBase64) {
    return cachedFontBase64;
  }

  const fontUrl = `${process.env.PUBLIC_URL || ''}/fonts/DejaVuSans.ttf`;
  const response = await fetch(fontUrl);
  if (!response.ok) {
    throw new Error('Failed to load PDF font');
  }

  const buffer = await response.arrayBuffer();
  cachedFontBase64 = arrayBufferToBase64(buffer);
  return cachedFontBase64;
}

export async function registerDejaVuSansFont(doc) {
  const base64 = await loadFontBase64();
  doc.addFileToVFS('DejaVuSans.ttf', base64);
  doc.addFont('DejaVuSans.ttf', 'DejaVuSans', 'normal');
  doc.setFont('DejaVuSans', 'normal');
}
